const location = [
    {
        id: 1,
        name: 'Desert king',
        img: require('./assets/location1.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 2,
        name: 'Desert king',
        img: require('./assets/location2.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 3,
        name: 'Desert king',
        img: require('./assets/location3.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 4,
        name: 'Desert king',
        img: require('./assets/location4.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 5,
        name: 'Desert king',
        img: require('./assets/location5.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 6,
        name: 'Desert king',
        img: require('./assets/location6.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 7,
        name: 'Desert king',
        img: require('./assets/location7.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 8,
        name: 'Desert king',
        img: require('./assets/location8.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 9,
        name: 'Desert king',
        img: require('./assets/location9.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 10,
        name: 'Desert king',
        img: require('./assets/location10.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 11,
        name: 'Desert king',
        img: require('./assets/location11.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 12,
        name: 'Desert king',
        img: require('./assets/location12.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 13,
        name: 'Desert king',
        img: require('./assets/location13.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 14,
        name: 'Desert king',
        img: require('./assets/location14.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 15,
        name: 'Desert king',
        img: require('./assets/location15.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
    {
        id: 16,
        name: 'Desert king',
        img: require('./assets/location16.png'),
        price: '1MBT per night',
        distance: '2345km away',
        availability: 'available for 2weeks stay',
        rating: '5star'
    },
]

export default location